import { useSelector } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import React from 'react'

import { CircularProgress } from '@material-ui/core'
import { getAuth } from '../../state/Auth/selectors'

export const useAuth = () => {
  const auth = useSelector(getAuth)
  const navigate = useNavigate()

  if (auth.loading) {
    return {
      loading: true,
      login: false,
      Loader: () => (
        <div style={{ margin: '1em' }}>
          <CircularProgress color="secondary" />
        </div>
      ),
    }
  }
  if (!auth.authorized) {
    navigate('/login')
    return { login: false }
  }
  return { loading: true, login: true }
}
